import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import AppAuthContainer from "../containers/AppAuthContainer";

const AppAuthPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <AppAuthContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default AppAuthPage;
